export interface ScrollMetrics {
    scrollLeft: number;
    scrollTop: number;
    scrollWidth: number;
    scrollHeight: number;
}

/**
 * Viewport coords → fractions of the scroll container's full content size.
 * Fractions survive different window sizes and scroll positions on the
 * receiving side (approximate — text reflow differences are acceptable).
 */
export function toFractions(
    clientX: number,
    clientY: number,
    rect: Pick<DOMRect, "left" | "top" | "width" | "height">,
    scroll: ScrollMetrics
): { xf: number; yf: number } | null {
    const relX = clientX - rect.left;
    const relY = clientY - rect.top;
    if (relX < 0 || relY < 0 || relX > rect.width || relY > rect.height) return null;
    const clamp = (n: number) => Math.min(1, Math.max(0, n));
    return {
        xf: clamp((relX + scroll.scrollLeft) / Math.max(1, scroll.scrollWidth)),
        yf: clamp((relY + scroll.scrollTop) / Math.max(1, scroll.scrollHeight))
    };
}

/** Fractions → container-relative pixels at the local scroll position. */
export function toPixels(
    xf: number,
    yf: number,
    rect: Pick<DOMRect, "left" | "top" | "width" | "height">,
    scroll: ScrollMetrics
): { x: number; y: number } {
    return {
        x: xf * Math.max(1, scroll.scrollWidth) - scroll.scrollLeft,
        y: yf * Math.max(1, scroll.scrollHeight) - scroll.scrollTop
    };
}
